import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'
import ContentWrapper from '../../../components/Layout/ContentWrapper'
import { getTeams } from '../API/endpoints'
import { columns, options } from '../utils/utils'

const Teams = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const axiosCancelSource = axios.CancelToken.source()
    
    const fetchTeams = async () => {
      setLoading(true)
      const result = await getTeams(axiosCancelSource.token)
      if (result.success) {
        setData(result.data)
      }
      setLoading(false)
    }

    fetchTeams()

    return () => {
      axiosCancelSource.cancel('Component unmounted')
    }
  }, [])

  const formatTableData = (teams) => {
    return teams.map((element, index) => {
      const date = element.created_at 
        ? moment(element.created_at).format('DD/MM/YYYY') 
        : ''
      
      const departmentNames = element.departments?.length > 0
        ? element.departments.map(d => d.name).join(', ')
        : 'Nuk ka'

      const updatedDate = element.updated_at && element.edited_by
        ? moment(element.updated_at).format('DD/MM/YYYY')
        : ''

      return [
        element.name,
        departmentNames,
        element.created_by?.email || '',
        date,
        element.edited_by?.email || '',
        updatedDate,
        <Link key={index} to={`/editTeams/${element._id}`}>
          <Button outline className='mb-1' color='warning' type='button'>
            <span>Modifiko</span>
          </Button>
        </Link>
      ]
    })
  }

  const tableData = formatTableData(data)

  return (
    <ContentWrapper>
      <div className='content-heading'>
        <div>Ekipet</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-end'
          }}
          className='ml-auto'
        >
          <Link to='/editTeams/'>
            <Button color='success' className='btn-oval'>
              Shto Ekip
            </Button>
          </Link>
        </div>
      </div>
      <Row>
        <Col>
          <MUIDataTable 
            title='Ekipet' 
            columns={columns} 
            options={options} 
            data={tableData} 
          />
        </Col>
      </Row>
    </ContentWrapper>
  )
}

export default Teams
